import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

const JsmAccessSettingsPageRouteComponent = LoadableAfterPaint({
	loader: async () =>
		import(
			/* webpackChunkName: "loadable-JsmAccessSettingsPageRouteComponent" */ './JsmAccessSettingsPageRouteComponent.tsx'
		),
});

export const JsmAccessSettingsPageRoute = () => <JsmAccessSettingsPageRouteComponent />;

JsmAccessSettingsPageRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: {
			name: 'jsmAccessSettingsScreen',
		},
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
